/*
    Configuration via Environment Variables. E.g.:
    REACT_APP_ANALYTICS_START_DATE=2018-06-01 REACT_APP_ANALYTICS_CHANNEL=mmatde REACT_APP_ANALYTICS_VIEW=Suchansicht npm run start
*/
type ConfigKey = 'ANALYTICS_START_DATE' | 'ANALYTICS_END_DATE' | 'ANALYTICS_CHANNEL' | 'ANALYTICS_VIEW' | 'ANALYTICS_UI_DEBUG' | 'TEXT_DEBUG';

export default function configString(key: ConfigKey, defaultValue = ''): string {
    return process.env['REACT_APP_' + key] || defaultValue;
}



// WEBPACK FOOTER //
// ./src/utility/Config.ts